/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Tokens_CopiedInputs */

const cs_import_tokens_copied = /** @type {(inputs: Import_Tokens_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token zkopírován`)
};

const en_import_tokens_copied = /** @type {(inputs: Import_Tokens_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token copied`)
};

/**
* | output |
* | --- |
* | "Token copied" |
*
* @param {Import_Tokens_CopiedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_tokens_copied = /** @type {((inputs?: Import_Tokens_CopiedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Tokens_CopiedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_tokens_copied(inputs)
	return cs_import_tokens_copied(inputs)
});